// Main App component - minimal orchestration layer
// Frontend developers can modify the overall layout and mode toggle here

import { useState } from "react";
import "./index.css";
import type { Mode } from "./types";
import { useHashMode } from "./hooks/useHashMode";
import { useSigningFlow } from "./hooks/useSigningFlow";
import { useVerifyMode } from "./hooks/useVerifyMode";
import { HashMode } from "./components/HashMode";
import { VerifyMode } from "./components/VerifyMode";

export function App() {
  const [mode, setMode] = useState<Mode>("hash");

  // Initialize hooks
  const hashMode = useHashMode();
  const signingFlow = useSigningFlow(hashMode.image, hashMode.hashes);
  const verifyMode = useVerifyMode();

  // Handle mode change - reset state when switching
  const handleModeChange = (newMode: Mode) => {
    setMode(newMode);
    if (newMode === "hash") {
      verifyMode.reset();
    } else {
      hashMode.reset();
      signingFlow.reset();
    }
  };

  return (
    <div className="container">
      {/* Hero Banner */}
      {/* <div className="hero-banner">
        <div className="network-dots" />
      </div> */}

      <div className="container-inner">
        <h1>Proteus</h1>
        <p className="subtitle">Secure image provenance via perceptual hashing</p>

        {/* Mode Toggle */}
        <div className="mode-toggle">
          <button
            className={`mode-btn ${mode === "hash" ? "active" : ""}`}
            onClick={() => handleModeChange("hash")}
          >
            Sign Image
          </button>
          <button
            className={`mode-btn ${mode === "verify" ? "active" : ""}`}
            onClick={() => handleModeChange("verify")}
          >
            Verify Image
          </button>
        </div>

        {/* Content based on mode */}
        {mode === "hash" ? (
          <HashMode hashMode={hashMode} signingFlow={signingFlow} />
        ) : (
          <VerifyMode verifyMode={verifyMode} />
        )}
      </div>
    </div>
  );
}

export default App;
